import React from 'react'
import { Row, Col } from 'react-styled-flexboxgrid'

import FullName from '~/components/traffic-tickets/steps/UserInfo/FullName'
import Email from '~/components/traffic-tickets/steps/UserInfo/Email'
import PhoneNumber from '~/components/traffic-tickets/steps/UserInfo/PhoneNumber'
import TABLE_SIZES from './tableSizes'

const InputRowNoPassword = () => {
  return (
    <Row>
      <Col {...TABLE_SIZES.fullName}>
        <FullName />
      </Col>
      <Col {...TABLE_SIZES.phoneNumber}>
        <PhoneNumber />
      </Col>
      <Col {...TABLE_SIZES.email}>
        <Email />
      </Col>
    </Row>
  )
}

export default InputRowNoPassword
